"use client";

import { useState } from "react";
import ContactForm from "@repo/next-shared/components/contact-form/contact-form";
import { useTranslations } from "next-intl";
import Link from "next/link";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui/components/ui/tabs";
import { Input } from "@repo/ui/components/ui/input";
import Chip from "@repo/ui/components/ui/chip";
import Toast from "@repo/ui/components/ui/toast";
import { sendSupport } from "@/data/support";
import { useRouter } from "next/navigation";

export default function ContactTabs() {
  const t = useTranslations();
  const [search, setSearch] = useState("");
  const [currentTab, setCurrentTab] = useState<"contact-us" | "faq">(
    "contact-us",
  );
  const router = useRouter();
  const [formSent, setFormSent] = useState<boolean>(false);

  const selectItems = [
    {
      value: "topic-option-account",
      label: t("Help.Contact-form.options.topic-option-account"),
    },
    {
      value: "topic-option-manage-catalog",
      label: t("Help.Contact-form.options.topic-option-manage-catalog"),
    },
    {
      value: "topic-option-manage-orders",
      label: t("Help.Contact-form.options.topic-option-manage-orders"),
    },
    {
      value: "topic-option-payments-and-invoices",
      label: t("Help.Contact-form.options.topic-option-payments-and-invoices"),
    },
  ];

  const faq = [
    { label: t("Home.faq.platform") },
    { label: t("Home.faq.return") },
    { label: t("Home.faq.costs") },
    { label: t("Home.faq.payments") },
    { label: t("Home.faq.categories") },
    { label: t("Home.faq.representative") },
    { label: t("Home.faq.billing") },
    { label: t("Home.faq.registration") },
    { label: t("Home.faq.proposal") },
    { label: t("Home.faq.spending") },
    { label: t("Home.faq.catalog") },
    { label: t("Home.faq.help") },
  ];

  const onSubmit = async (data: any) => {
    await sendSupport(data);
    setFormSent(true);
  };

  return (
    <>
      <Tabs
        defaultValue={currentTab}
        onValueChange={setCurrentTab as any}
        className="w-full max-w-4xl"
      >
        <p className="mb-[40px] max-md:mb-[20px] text-center text-lg sm:text-2xl font-normal leading-none">
          {t.rich(`Home.contactUs.${currentTab}-description`, {
            strong: (chunks) => <strong className="font-bold">{chunks}</strong>,
            br: () => <br />,
          })}
        </p>
        <TabsList className="grid w-full grid-cols-2 mb-8">
          <TabsTrigger className="h-full" value="contact-us">
            {t(`Home.contactUs.tabs.contactUs`)}
          </TabsTrigger>
          <TabsTrigger className="whitespace-normal px-[25px]" value="faq">
            {t(`Home.contactUs.tabs.faq`)}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="contact-us">
          <Toast
            label={t("Help.Contact-form.message-sent")}
            icon="Check"
            visible={formSent}
            setIsVisible={setFormSent}
          />
          <ContactForm
            className="max-md:mt-8"
            selectItems={selectItems}
            onSubmit={onSubmit}
          />
        </TabsContent>

        <TabsContent value="faq">
          <div>
            <div className="w-full my-[20px] text-left">
              <form id="search-form" action="help" method="GET">
                <Input
                  rounded
                  icon="Search"
                  tabIndex={2}
                  actionIcon
                  onActionIconClick={() => {
                    router.push(`help?search=${search}`);
                  }}
                  id="search"
                  name="search"
                  label={t("Home.contactUs.searchForAnything")}
                  type="search"
                  onChange={(e) => setSearch(e.target.value)}
                  value={search}
                />
              </form>
            </div>
            <div className="my-5 font-bold flex flex-wrap gap-5 justify-center">
              {faq?.map((el, idx) => (
                <Link key={idx} href={`help?search=${el.label}`}>
                  <Chip className="px-4 py-2 text-center">{el.label}</Chip>
                </Link>
              ))}
            </div>
          </div>
        </TabsContent>
      </Tabs>
    </>
  );
}
